// LOGOMAN PRO — re-import a previously exported .logoman.json source file.

import type { Layout } from "../state/logoStore";

export interface ImportedProject {
  title: string;
  slogan: string;
  iconId: string | null;
  titleFont: string;
  sloganFont: string;
  titleColor: string;
  sloganColor: string;
  iconColor: string;
  background: string;
  layout: Layout;
  titleSize: number;
  sloganSize: number;
  iconScale: number;
}

const VALID_LAYOUTS: Layout[] = ["icon-top", "icon-left", "icon-right", "text-only", "icon-only"];

export async function importProjectFile(file: File): Promise<ImportedProject> {
  const text = await file.text();
  let raw: unknown;
  try {
    raw = JSON.parse(text);
  } catch {
    throw new Error("Not a valid LOGOMAN PRO project file (JSON parse failed)");
  }
  if (!raw || typeof raw !== "object") throw new Error("Project file is empty or invalid");

  const r = raw as Record<string, unknown>;
  const str = (k: string, fallback = "") => (typeof r[k] === "string" ? (r[k] as string) : fallback);
  const num = (k: string, fallback = 0) => (typeof r[k] === "number" ? (r[k] as number) : fallback);
  const layout = VALID_LAYOUTS.includes(r.layout as Layout) ? (r.layout as Layout) : "icon-top";

  return {
    title: str("title", "Imported"),
    slogan: str("slogan", ""),
    iconId: typeof r.iconId === "string" || r.iconId === null ? (r.iconId as string | null) : null,
    titleFont: str("titleFont", "Inter"),
    sloganFont: str("sloganFont", "Inter"),
    titleColor: str("titleColor", "#0c2572"),
    sloganColor: str("sloganColor", "#475569"),
    iconColor: str("iconColor", "#0c2572"),
    background: str("background", "#ffffff"),
    layout,
    titleSize: num("titleSize", 56),
    sloganSize: num("sloganSize", 18),
    iconScale: num("iconScale", 1),
  };
}
